import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

// Components
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

// Styles
import makeStyles from '@material-ui/core/styles/makeStyles';

function MicrosoftSubscriptionTable({
  companyName,
  subscriptionData,
  confirmedSubscriptionData,
  handleChangeCompany,
  handleKeyPress,
}) {
  const classes = useStyles();
  const siftSubscription = _get(subscriptionData, 'siftSubscription');
  const msSubscription = _get(subscriptionData, 'subscription');
  const shouldRenderCompanyInput =
    _get(subscriptionData, ['siftSubscription', 'source']) !== 'database' &&
    _isEmpty(confirmedSubscriptionData);

  return (
    <div className={classes.root} data-testid="microsoft-subscription-table">
      <div className={classes.inline}>
        <Typography className={classes.labels} variant="body2">
          Subscription Name:
        </Typography>
        <Typography variant="body1">{_get(msSubscription, 'name')}</Typography>
      </div>
      <div className={classes.inline}>
        <Typography className={classes.labels} variant="body2">
          Plan:
        </Typography>
        <Typography variant="body1">{_get(msSubscription, 'planId')}</Typography>
      </div>
      <div className={classes.inline}>
        <Typography className={classes.labels} variant="body2">
          Status:
        </Typography>
        <Typography variant="body1">{_get(msSubscription, 'saasSubscriptionStatus')}</Typography>
      </div>
      <div className={classes.inline}>
        <Typography className={classes.labels} variant="body2">
          User Name:
        </Typography>
        <Typography variant="body1">{_get(siftSubscription, 'userName')}</Typography>
      </div>
      <div className={classes.inline}>
        <Typography className={classes.labels} variant="body2">
          User Email:
        </Typography>
        <Typography variant="body1">
          {_get(siftSubscription, 'userEmail') || _get(siftSubscription, 'userUsername')}
        </Typography>
      </div>
      <div className={classes.inline}>
        <Typography className={classes.labels} htmlFor="company-input" variant="body2">
          Company Name:
        </Typography>
        {shouldRenderCompanyInput ? (
          <TextField
            inputProps={{ 'aria-label': 'company-input' }}
            hiddenLabel
            id="company-input"
            autoFocus
            placeholder="Company Name"
            variant="outlined"
            onChange={handleChangeCompany}
            value={companyName}
            onKeyPress={handleKeyPress}
            size="small"
          />
        ) : (
          <Typography variant="body1">
            {_get(siftSubscription, 'companyName') ||
              _get(confirmedSubscriptionData, 'companyName')}
          </Typography>
        )}
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => {
  return {
    root: {
      marginBottom: theme.spacing(5),
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
        marginLeft: '10%',
      },
    },
    inline: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1.5),
    },
    labels: {
      width: 200,
    },
  };
});

MicrosoftSubscriptionTable.propTypes = {
  companyName: PropTypes.string,
  subscriptionData: PropTypes.object.isRequired,
  confirmedSubscriptionData: PropTypes.object.isRequired,
  handleChangeCompany: PropTypes.func,
  handleKeyPress: PropTypes.func,
};

export default MicrosoftSubscriptionTable;
